import { render, staticRenderFns } from "./SpeedingDoubleIcon.vue?vue&type=template&id=572227f0&scoped=true&"
import script from "./SpeedingDoubleIcon.vue?vue&type=script&lang=js&"
export * from "./SpeedingDoubleIcon.vue?vue&type=script&lang=js&"
import style0 from "./SpeedingDoubleIcon.vue?vue&type=style&index=0&id=572227f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572227f0",
  null
  
)

export default component.exports